import React, {useState} from 'react'
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import DatePicker from "react-datepicker";


const ObjectiveForm = (props) =>{

    const [input, setInput] = useState("")
    const [textArea, setTextArea] = useState("")
    const [startDate, setStartDate] = useState("");

    return (
        <div>
            <div className="objetive-form-container" id={props.objectiveId} data-saved={props.saved}>
                {!props.saved && <a onClick={() => props.removeObjectiveHandler(props.objectiveId)} className="delete-button"><CloseIcon/></a>}
                {props.saved && <a className="check-button"><CheckIcon/>Guardado</a>}

                <input className="objective-title" type="text" value = {input} placeholder="Nombre del objetivo" onChange={(e) => {setInput(e.target.value)} } readOnly={props.saved} />
                <textarea className="objective-description" value = {textArea} rows="4" onChange={(e) => {setTextArea(e.target.value)} } placeholder="Descripción del objetivo" ></textarea>
                <span className="datepicker-label">Fecha de Término (Opcional):</span> <DatePicker className="datepicker-custom objective-deadline" selected={startDate} dateFormat="dd-MM-yyyy" onChange={(date) => setStartDate(date)} />
                <hr />
            </div>
        </div>
    )
}

export default ObjectiveForm
